var exports = {
  "label": "x24da60e8--d42af0--label",
  "dark-theme": "x24da60e8--d42af0--dark-theme",
};

module.exports = exports;
